import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
// import moment from 'moment'
// import GolfCourseStore from './GolfCourseStore'
// import DatesStore from './DatesStore'
// import ConfigStore from './ConfigStore'
// import UserStore from './UserStore'

class TournamentStore {

  @observable loading
  @observable registered
  @observable error
  @observable registrations
  @observable currentTournament

  constructor() {
    this.loading = false
    this.error = false
    this.registered = false
    this.registrations = null
    this.currentTournament = null
  }

  @computed get registrationCount() {
    return this.registrations.length
  }

  @computed get isError() {
    return this.error
  }

  @action setLoading = (state) => {
    this.loading = state
  }

  @action setError = (state) => {
    this.error = state
  }

  @action setRegistered = (state) => {
    this.registered = state
  }

  @computed get isRegistrations() {
    return this.registrations && this.registrations[0].objectId ? true : false
  }

  @action setRegistrations = (registrations) => {
    this.registrations = registrations
  }

  @action setCurrentTournament = (currentTournament) => {
    this.currentTournament = currentTournament
  }

  @action sortRegistrations = () => {
    if (this.registrations)
      this.registrations = _.orderBy(this.registrations, ['createdAt'], ['desc'])
  }/*
  if (this.allResidenceBookings) {
      this.allResidenceBookings = _.orderBy(this.allResidenceBookings, ['bookingStart.iso'], ['asc'])
  }*/


  getRegistrations = () => {

    let allRegistrations = []

    let registrationQuery = new Parse.Query("TournamentRegistration")
    registrationQuery.include('participant')
    registrationQuery.include('participant.company')
    registrationQuery.include('tournament')
    registrationQuery.each((reg, key) => {
      allRegistrations.push(reg.toJSON())
      console.log(allRegistrations.find(req => req.objectId === "4UgU0979Lw"));
    }).then(res => {
      this.setRegistrations(allRegistrations)
      if (allRegistrations.length === 0) {
        //this.setUserFreeBookings(UserStore.maxBookings)
      } else {
        this.setRegistrations(allRegistrations)
        this.sortRegistrations()
      }
    }).catch(err => {
      console.error("error active bookings", err)
    })

  }

  getCurrentTournament = async () => {
    try {
      const publicTournamentCount = await new Parse.Query('Tournament').equalTo('isPublic', true).count()

      if(publicTournamentCount < 1) return;

      const lastTournament = await new Parse.Query('Tournament').equalTo('isPublic', true).descending('createdAt').first()

      this.setCurrentTournament(lastTournament)
      console.log(lastTournament);

    } catch (error) {
      console.error(error);
    }
  }

  register = (data) => {
    let tournament = new Parse.Object("Tournament", { id: data.tournament })
    let externalParticipants = [{ ...data.externalParticipant }]

    const RegistrationParseObj = Parse.Object.extend("TournamentRegistration")
    let newRegistration = new RegistrationParseObj()

    newRegistration.set("tournament", tournament)
    newRegistration.set("participant", Parse.User.current())
    newRegistration.set("externalParticipants", externalParticipants)
    newRegistration.set("eventOnly", data.onlyEvent)
    newRegistration.set("guestEventOnly", data.guestOnlyEvent)

    this.loading = true
    this.setLoading(true)

    if (data.hcpParticipant) {
      let user= Parse.User.current()
      user.save().then(function() {
          user.set("handicap", Number.parseFloat(data.hcpParticipant))
          user.save()
      }, function(error) {
        console.error("error user hcp", error)
        this.setError(true)
      });
		}

    newRegistration.save()
      .then((savedRegistration) => {
        this.setLoading(false)
        this.setRegistered(true)
        this.setError(false)
      })
      .catch((error) => {
        console.error("Could not save registration", error)
        this.setLoading(false)
        this.setError(true)
      })
  }



}

const store = new TournamentStore()
export default store



// WEBPACK FOOTER //
// /src/stores/TournamentStore.js